import { Component } from '@angular/core';

import { environment } from '../../environments/environment';

@Component({
  selector: 'app-about',
  imports: [],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
  // standalone: false
})
export class AboutComponent {
  env = environment;
}
